'use client';

import { Banner } from '@/app/[locale]/(welcome)/auth/_components/Banner';
import SensitiveQueryParamsScrubber from '@/app/[locale]/(welcome)/auth/_components/SensitiveQueryParamsScrubber';
import { Root, LayoutWithBannerWrapper } from '@/app/[locale]/(welcome)/auth/_styled';
import { HideBelow } from '@/components/Media';

export default function LayoutWithBanner({ children }) {
    return (
        <LayoutWithBannerWrapper>
            <SensitiveQueryParamsScrubber />
            <HideBelow md>
                <Banner />
            </HideBelow>

            <Root>
                {children}
            </Root>
        </LayoutWithBannerWrapper>
    );
}
